<svg class="svpc" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 117 40">
  <defs>
    <style>
      .svpc .svpc__ants {
      stroke-dasharray: 0 0 0 0 0 0 3.186 2.23 0 0 0 0;
      fill:none;
      stroke: currentColor;
      stroke-linecap:round;
      stroke-linejoin:round;
      }
      .svpc .svpc__snips {
      fill: currentColor;
      stroke: none;
      }
      .svpc__blob {
      fill: currentColor;
      }
    </style>
  </defs>


  <path class="svpc__ants"
        d="M96,33.2c1.7,0,5.3,0,7.3,0s3.3,0,5.6-.2,3.8-2.7,3.8-5,.2-13.6.2-14.9c0-3.4-2.1-6.3-9.6-5.9-4.1.2-29.8.2-29.8.2"/>
  <path class="svpc__ants"
        d="M17.9,7.2h-6.3c-3.6,0-6.3,2.3-6.5,7.2s-.3,10.7,0,13.7c.4,2.9,1.5,4.8,7.6,4.9,0,0,16.6-.3,25.7-.2s27.7.4,39.6.4"/>
  <path class="svpc__snips"
        d="M89.7,33.4c-.4-.1-.8-.3-1.2-.4.4-.2.8-.3,1.2-.5,1.1-.4,3.7-1.5,3.7-1.5,0,0-.2-.3-.4-.6-.2-.2-.5-.2-.8-.1-.7.1-2.3.6-5.4,1.9-.8-.5-1.6-.6-2.1-.5-.5,0-.5,0-.4-.3s.5-.9.1-1.4c-.6-1.3-2.1-1-2.7-.1-.6.9-.5,2.4.9,2.6,1.4.1,2.4-.3,2.8,0,.4.3.3.3.4.5-.1.2-.2.3-.4.5-.2.2-1.4,0-2.8.2-1.2.2-1.4,1.5-1,2.4.5,1,2.1.9,2.6.2.4-.6.3-1.2.1-1.6,0-.1-.3-.4.3-.4.6,0,1.4,0,2.1-.6,2.8,1.1,5,1.9,5.6,1.8.6-.1.9-.8.8-.9-1.1-.4-2.4-.9-3.5-1.3ZM83.6,31.3c-.3.4-1.3.6-1.5-.3s.9-1.4,1.4-1c.5.4.4,1,0,1.4ZM83.5,36c-.5.3-1.4,0-1.4-.9,0-.9,1.1-.8,1.5-.4.3.4.4,1,0,1.3Z"/>
  <g>
    <path class="svpc__blob"
          d="M21.6,7.9c-.4,0-.3.6-.3.8,0,.3,0,.8,0,1.1,0,.1-.2,0-.5,0-.1,0-.3,0-.4-.1,0-1.5-.1-3.4,0-5,.4-.2.9,0,1.3,0,.9,0,1.9.2,2.2,1.2.3,1.5-.8,2.3-2.2,2.1h0ZM21.7,5.3c-.1,0-.2,0-.3,0h0c0,.6,0,1.1,0,1.7h0c.5,0,1.1.1,1.5-.2.5-1-.2-1.5-1.2-1.4Z"/>
    <path class="svpc__blob"
          d="M25.3,4.6c1,0,2.3-.3,3.1.6.6.6.5,1.7,0,2.2-.1.1-.4.2-.5.4.1.6.9,1.3.9,1.9-.2.1-.4,0-.6,0-.5-.1-.6-.8-.9-1.2-.2-.4-.3-.9-.9-.8-.9,0-.2,1.3-.5,1.8-.2.2-.7.2-.8-.1,0-1.4,0-2.8,0-4.2,0-.2,0-.6.1-.8h0s0,0,0,0ZM26.4,5.3c-.5-.2-.4.7-.4,1.1,0,.9.2.8.9.7,0,0,.5,0,.8-.3.4-.5.3-1.1-.3-1.4-.2-.1-.8-.1-1-.1h0Z"/>
    <path class="svpc__blob"
          d="M29.7,6.8c0-.9.8-1.7,1.6-2.1,1.2-.4,2.2-.2,2.8.4.7.6,1.1,1.6,1,2.6-.1.8-.7,1.6-1.7,2.1-.7.2-1.3.2-1.9,0-1.1-.4-1.9-1.5-1.7-2.9ZM32.9,8.9c.9-.3,1.5-1.2,1.1-2.5-.6-1.2-1.7-1.4-2.5-.9-.6.4-1.1.8-.9,2,.2,1.2,1.5,1.7,2.3,1.4Z"/>
    <path class="svpc__blob"
          d="M37.5,6.9c-.3-.2-.3-.2-.3.1,0,.3,0,1,0,1.8,0,.3,0,.6,0,.8-.2.2-.5.1-.8,0-.2-.3,0-1.1,0-1.5,0-.9,0-1.8,0-2.7,0-.8,0-1.3.7-.3.5.4.8.8,1.2,1.3.2.3.6.9.9.3.7-.7,1.2-1.4,1.9-2.1.3-.2.2.2.2.4,0,1.6.1,3,0,4.5-.2.2-.6.2-.8,0-.2-.4,0-1,0-1.6,0-.8.2-2.1-.7-.7-.2.2-.6.9-1,.9,0,0-1-1.1-1.2-1.3h0Z"/>
    <path class="svpc__blob"
          d="M42.4,6.8c0-.9.8-1.7,1.6-2.1,1.3-.5,2.4-.1,3,.6.6.7.9,1.6.7,2.5-.2.8-.7,1.5-1.7,1.9-1.1.3-2.1,0-2.8-.5-.6-.6-1-1.4-.9-2.4h0ZM43.3,7.6c.3,1.3,1.3,1.6,2.1,1.4.9-.2,1.7-1.2,1.3-2.6-.5-1.1-1.5-1.3-2.3-1-.7.3-1.4.9-1.1,2.2Z"/>
    <path class="svpc__blob"
          d="M54.5,5c0,.1,0,.6-.2.5-4.2-1.5-4.1,4.9,0,3.2.3,0,.2.8,0,.9-3.3,1.5-5.9-3.1-2.6-4.9.8-.3,2.2-.5,2.8.2h0Z"/>
    <path class="svpc__blob"
          d="M55.3,6.8c0-.9.8-1.7,1.6-2.1,1.6-.6,2.9.1,3.5,1.2.7,1.3.4,3.1-1.4,3.8-1,.3-1.9.1-2.5-.3-.8-.5-1.2-1.5-1.1-2.6ZM56.2,7.6c.2,1.2,1.4,1.6,2.3,1.3s1.6-1.2,1.2-2.5c-.6-1.2-1.7-1.4-2.6-.9-.6.4-1.1.9-.8,2.1Z"/>
    <path class="svpc__blob"
          d="M63,9.8c-.2,0-.8,0-1,0-.2-.2,0-.6,0-.8,0-1.4,0-2.8,0-4.1,0-.4.6-.2.9-.2,1.3-.2,2.2.2,2.8.8.5.5.8,1.2.8,1.9s-.3,1.4-.9,1.9c-.6.5-1.4.7-2.4.6ZM63,5.3c-.3,0-.2.6-.2.7,0,1,0,1.9,0,2.9.7.2,1.3.1,1.8-.1.5-.3.8-.8.8-1.3s0-1.1-.4-1.5c-.4-.4-1-.7-2-.6h0Z"/>
    <path class="svpc__blob"
          d="M70.6,9.8c-.9,0-1.9,0-2.8,0-.4,0-.3-.5-.3-.9,0-1.4,0-2.8,0-4.1,0-.5.7-.2,1-.2.7,0,1.6,0,2.2,0,.2.1.3.4,0,.6-.6.2-1.3,0-2,.1-.3,0-.2.4-.2.6,0,.2,0,.5.1.8.2,0,.6,0,.8,0,.4,0,1.1-.3,1.1.4-.1.6-.8.2-1.3.3-.2,0-.4,0-.6,0-.2.2-.1.5-.1.7,0,.5,0,.8.6.8.6,0,1.1,0,1.8,0,.2.1.2.7-.2.7h0Z"/>
  </g>

</svg>